(ns bec-cljs-common.components.modal
  (:require [reagent.core :as r]
            [re-frame.core :as rf]))

(defonce variables (r/atom {}))

(rf/reg-event-fx :modal
  (fn [{:keys [db]} [_ modal-key props]]
    (swap! variables assoc modal-key props)
    {:db db}))

(rf/reg-event-fx :update-modal-props
  (fn [{:keys [db]} [_ modal-key props]]
    (let [current-props (get @variables modal-key)
          updated-props (merge current-props props)]
      (swap! variables assoc modal-key updated-props)
      {:db db})))

(rf/reg-event-fx :open-modal
  (fn [_ [_ modal-key props]]
    (let [props (or props (when (map? modal-key) modal-key) {})
          modal-key (or (when (map? modal-key) (:modal-key modal-key)) modal-key)
          animation-duration (or (:animation-duration props) 350)]
      (swap! variables assoc modal-key (assoc props :active? true
                                                    :animate-in? true
                                                    :modal-key modal-key))
      {:fx [[:dispatch-later {:ms animation-duration
                              :dispatch [:update-modal-props modal-key (assoc props :animated-in? true)]}]
            (when (:on-open props)
              [:dispatch (:on-open props)])
            (when (:on-animated-in-event props)
              [:dispatch-later {:ms animation-duration
                                :dispatch (:on-animated-in-event props)}])]})))

(rf/reg-event-fx :close-modal
  (fn [_ [_ modal-key props]]
    (let [props (or props (when (map? modal-key) modal-key) {})
          modal-key (or (when (map? modal-key) (:modal-key modal-key)) modal-key)
          animation-duration (:animation-duration props)
          on-close-event (:on-close-event props)
          close-immediately? (and (<= animation-duration 0)
                               (not (nil? animation-duration)))
          animation-duration (or animation-duration 250)]
      (if close-immediately?
        (swap! variables assoc modal-key nil)
        (swap! variables
          #(-> (assoc-in % [modal-key :animate-in?] false)
             (assoc-in [modal-key :animate-out?] true))))
      {:fx [(when (and close-immediately? on-close-event)
              [:dispatch on-close-event])
            (when (and (not close-immediately?) on-close-event)
              [:dispatch-later {:ms animation-duration
                                :dispatch on-close-event}])
            (when-not close-immediately?
              [:dispatch-later {:ms animation-duration
                                :dispatch [:modal modal-key nil]}])]})))

(defn header [& [props]]
  (into
    [:header.modal-card-head
     (when (map? props)
       props)]
    (r/children (r/current-component))))

(defn body [& [props]]
  (into
    [:section.modal-card-body
     (when (map? props)
       props)]
    (r/children (r/current-component))))

(defn footer [& [props]]
  (into
    [:footer.modal-card-foot
     (when (map? props)
       props)]
    (r/children (r/current-component))))

(defn view [& [{:keys [key
                       modal-vars
                       modal-props
                       background-props
                       modal-card-props
                       modal-key]}]]
  (let [modal-vars (or modal-vars (get @variables modal-key))
        active? (:active? modal-vars)
        animate-out? (:animate-out? modal-vars)
        animate-in? (:animate-in? modal-vars)]
    (when active?
      [:div.modal
       (merge
         modal-props
         {:key key
          :class (str (:class modal-props) (when active? " is-active "))
          :id (if (keyword? modal-key)
                (name modal-key)
                "modal-no-key")})
       [:div.modal-background
        (merge
          {:class (str
                    (when animate-out? " fade-out ")
                    (when animate-in? " fade-in "))
           :on-click (if (keyword? modal-key)
                       #(rf/dispatch [:close-modal modal-key])
                       (fn [] nil))}
          background-props)]
       (into
         [:div.modal-card
          (merge
            modal-card-props
            {:class (or
                      (:class modal-card-props)
                      (str
                        (when animate-out? " fade-out-bottom ")
                        (when animate-in? " fade-in-top ")))
             :style (:style modal-card-props)})]
         (r/children (r/current-component)))])))